import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Filtro } from '../model/filtro.model';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class IntinerarioService extends BaseService{
 
    private headers: HttpHeaders;

    constructor(private http: HttpClient) { 
        super();
        this.headers = this.createAHeader();    
    }

    public count(filtro: Filtro): Promise<any> {
        return this.http.post(`${environment.apiUrl}intinerario/count`,filtro, { headers: this.headers }).toPromise();
    }
    
    public encontrarProdutosPeloIdIntinerario(id): Promise<any> {
        return this.http.get(`${environment.apiUrl}intinerario/produtos/${id}`, { headers: this.headers }).toPromise();
    }

    public encontrarPeloId(id: any): Promise<any> {
        return this.http.get(`${environment.apiUrl}intinerario/${id}`, { headers: this.headers }).toPromise();
    }

    public listar(filtro: Filtro): Promise<any> {
        return this.http.post(`${environment.apiUrl}intinerario/list`, filtro, { headers: this.headers }).toPromise();
    }
    
    public encontrarPeloNome(filtro: any): Promise<any> {
        return this.http.post(`${environment.apiUrl}intinerario/listByName`, filtro, { headers: this.headers }).toPromise();
    }
    
    public deletar(id): Promise<any> {
        return this.http.delete(`${environment.apiUrl}intinerario/${id}`, { headers: this.headers }).toPromise();
    }

    public editar(pacote): Promise<any> {
        return this.http.put(`${environment.apiUrl}intinerario`, pacote, { headers: this.headers }).toPromise();
    }

    
    public repasseSeguidoDeBaixa(pacote): Promise<any> {
        return this.http.post(`${environment.apiUrl}intinerario/repasseBaixa`, pacote, { headers: this.headers }).toPromise();
    }

    public criar(intinerario): Promise<any> {
        return this.http.post(`${environment.apiUrl}intinerario`, intinerario, { headers: this.headers }).toPromise();
    }

}